export const ServiceClassMenuIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '20'}
    height={props?.height || '20'}
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.8415 11.5776L5.83317 19.1693L9.99984 16.6693L14.1665 19.1693L13.1582 11.5693M15.8332 6.66927C15.8332 9.89093 13.2215 12.5026 9.99984 12.5026C6.77818 12.5026 4.1665 9.89093 4.1665 6.66927C4.1665 3.44761 6.77818 0.835938 9.99984 0.835938C13.2215 0.835938 15.8332 3.44761 15.8332 6.66927Z"
      stroke={props?.color || '#101828'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
